import Service from './service';
import { AxiosResponse } from 'axios';

const Config = require('Config');

class FinancialService extends Service {
  constructor() {
    super(Config.financialServiceUrl);
  }

  async getAccountName(clientNumber): Promise<any> {
    const url = `client/account/${clientNumber}`;
    const response: AxiosResponse = await this.axios.get(url);
    return response.data;
  }

  async getAccounts(clientNumbers): Promise<any> {
    const url = 'client/accounts';
    const body = { clientNumbers };
    const response: AxiosResponse = await this.axios.post(url, body);
    if (!response || response.status < 200 || response.status > 300) {
      throw new Error(
        `[financial.service] Error: Non success status ${response.status} returned from getAccounts axios call. `,
      );
    }
    return response.data;
  }
}

export default new FinancialService();